import { Button, useTheme } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import type { SecondaryButtonProps } from './SecondaryButton.types';

const SecondaryButton: FC<SecondaryButtonProps> = ({
  startAdornment,
  endAdornment,
  text,
  ...rest
}) => {
  const themeHook = useTheme();

  return (
    <Button
      {...rest}
      sx={[themeHook.mixins.secondaryButtonStyle, ...castArray(rest.sx)]}
      startIcon={startAdornment}
      endIcon={endAdornment}
      data-test={rest['data-test']}
    >
      {text}
    </Button>
  );
};

export default SecondaryButton;
